// TODO MR: Remove console.log
console.log('test');
